import { httpGet } from 'common/helpers/http'

import { Paging } from 'common/__content-api/v4/paging'
import { validate } from 'common/__content-api/v4/get-topic-listing'
import { isFeatureEnabled } from 'common/feature-togglings/features'
import { DataLoaderGlobalParams } from 'common/data/resources'

export interface Options {
    paging?: Paging
    includePremium?: boolean
}

export const getRelatedPublications = (
    services: DataLoaderGlobalParams,
    publicationId: string,
    options: Options
) => {
    const include_premium =
        // option defaults to true, which is then confirmed/denied by the feature toggle
        // see commments in https://bitbucket.swmdigital.io/projects/PROD/repos/web/pull-requests/1501/overview
        options.includePremium !== false &&
        isFeatureEnabled(services.store.getState().toggles, 'digital-subscriptions', false)

    const { paging = {} as Paging } = options
    const query = {
        page: paging.page || 1,
        page_size: paging.pageSize || 4,
        page_offset: paging.pageOffset || 0,
        include_premium: include_premium || undefined,
    }

    return httpGet({
        log: services.log,
        validate,
        baseUrl: services.config.contentApi,
        path: `v4/publication/${publicationId}/related`,
        query,
        customHeaders: {
            caller: services.config.apiCallerHeader,
        },
    })
}
